import {
    Breadcrumb,
    Layout,
    Form,
    Input,
    DatePicker,
    Select,
    Button,
    Row,
    Col,
    InputNumber,
    Card,
    Switch,
    message
} from 'antd';
import { APPBACKGROUND_COLOR } from '../appsettings';
import Headerdiv from '../layout/header';
import { Content } from 'antd/es/layout/layout';
import { Link } from 'react-router-dom';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Footerdiv from '../layout/footer';
import axiosClient from '../../api/axiosClient';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;

export const TrainerCreate = () => {
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const USERID = localStorage.getItem("USERID");

    const onFinish = async (values) => {
        const payload = {
            ...values,
            birthday: values.birthday ? values.birthday.format("YYYY-MM-DD") : null,
            status: values.status ? true : false,
            by: USERID
        };

        try {
            const response = await axiosClient.post(`/trainer/add_trainer.php`, payload);

            if (response.data.status === "success") {
                message.success(response?.data?.message || "System error. Please try again.");
                form.resetFields();
                navigate('/trainers/view');
            } else {
                message.error(response?.data?.message || "System error. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            message.error(error.response?.data?.message || "System error. Please try again.");
        }
    };

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: "10px" }}>
                <Breadcrumb style={{ marginBottom: 10 }}>
                    <Breadcrumb.Item>
                        <Link to={"/trainers/view"}>Trainers</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Create A Trainer</Breadcrumb.Item>
                </Breadcrumb>

                <Form layout="vertical" form={form} onFinish={onFinish}>

                    {/* BASIC DETAILS */}
                    <Card title="Basic Information">
                        <Row gutter={[16, 16]}>
                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    type="number"
                                    name="trainer_id"
                                    label="Trainer ID"
                                    rules={[{ required: true, message: "Trainer ID is required" }]}
                                >
                                    <Input placeholder="Enter Trainer ID" />
                                </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    name="nic"
                                    label="NIC"
                                    rules={[{ required: true, message: "NIC is required" }, {
                                        pattern: /^([0-9]{9}[VvXx]|[0-9]{12})$/,
                                        message: "Enter valid Sri Lankan NIC"
                                    }]}
                                >
                                    <Input placeholder="Enter NIC" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={8}>
                                <Form.Item
                                    name="name"
                                    label="Full Name"
                                    rules={[{ required: true, message: "Name is required" }]}
                                >
                                    <Input placeholder="Enter Full Name" />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={8} md={4}>
                                <Form.Item
                                    name="birthday"
                                    label="Birthday"
                                    rules={[{ required: true, message: "Birthday is required" }]}
                                >
                                    <DatePicker style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={8} md={4}>
                                <Form.Item
                                    name="gender"
                                    label="Gender"
                                    rules={[{ required: true, message: "Select Gender" }]}
                                >
                                    <Select placeholder="Select Gender">
                                        <Option value="M">Male</Option>
                                        <Option value="F">Female</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    name="contact_no"
                                    label="Contact Number"
                                    rules={[
                                        { required: true, message: "Contact number is required" },
                                        { pattern: /^(?:0\d{9}|\+94\d{9})$/, message: "Enter valid phone number" }
                                    ]}
                                >
                                    <Input placeholder="Enter phone number" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    name="emergency_contact"
                                    label="Emergency Contact"
                                    rules={[
                                        { required: true, message: "Emergency contact is required" },
                                        { pattern: /^(?:0\d{9}|\+94\d{9})$/, message: "Enter valid phone number" }
                                    ]}
                                >
                                    <Input placeholder="Enter emergency contact" />
                                </Form.Item>
                            </Col>

                            <Col xs={16}>
                                <Form.Item
                                    name="address"
                                    label="Address"
                                    rules={[{ required: true, message: "Address is required" }]}
                                >
                                    <Input.TextArea rows={1} placeholder="Enter Address" />
                                </Form.Item>
                            </Col>

                            {/* TRAINER-SPECIFIC */}
                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    name="specialization"
                                    label="Specialization"
                                    rules={[{ required: true, message: "Specialization is required" }]}
                                >
                                    <Input placeholder="e.g., Strength, Yoga, CrossFit" />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={4}>
                                <Form.Item
                                    name="experience_years"
                                    label="Experience (Years)"
                                    rules={[{ required: true, message: "Experience required" }]}
                                >
                                    <InputNumber min={0} style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={6}>
                                <Form.Item name="status" label="Status">
                                    <Switch />
                                </Form.Item>
                            </Col>

                            <Col xs={24}>
                                <Form.Item name="health_conditions" label="Health Conditions">
                                    <ReactQuill theme="snow" />
                                </Form.Item>
                            </Col>

                            {/* --- BUTTONS MOVED INSIDE THE CARD --- */}
                            <Col xs={24}>
                                <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                    <Col>
                                        <Button onClick={() => form.resetFields()}>Clear</Button>
                                    </Col>
                                    <Col>
                                        <Button type="primary" htmlType="submit">Create Trainer</Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </Content>
            <Footerdiv />
        </Layout>
    );
};